import { EditDataTypesEnum } from './edit-data-types.enum';
import { EditRecordRequest } from './record-edit.interface';

export enum SpecialRecordEdit {
  AreAndCountryOfAre,
  ContractStatusAndPlaceOfAction,
  SOG
}

export class EditRecordHelper {
  public static date(
    key: 'startDate' | 'endDate',
    recordKey1: 'validFrom' | 'validTo',
    min: Date,
    max: Date
  ): EditRecordRequest {
    return {
      type: EditDataTypesEnum.DATE,
      key,
      recordKey1,
      min,
      max
    };
  }

  public static readonly startDate: EditRecordRequest = {
    type: EditDataTypesEnum.DATE,
    key: 'startDate'
  };

  public static readonly endDate: EditRecordRequest = {
    type: EditDataTypesEnum.DATE,
    key: 'endDate'
  };

  public static readonly baseSalary: EditRecordRequest = {
    type: EditDataTypesEnum.NUMBER,
    key: 'baseSalary',
    recordKey1: 'initialSnapshot',
    recordKey2: 'baseSalary'
  };

  public static readonly baseSalaryCurrency: EditRecordRequest = {
    type: EditDataTypesEnum.DROPDOWN,
    key: 'baseSalaryCurrency',
    recordKey1: 'initialSnapshot',
    recordKey2: 'baseSalaryCurrency'
  };

  public static readonly initialLineManager: EditRecordRequest = {
    type: EditDataTypesEnum.EMPLOYEE,
    key: 'lineManagerId',
    recordKey1: 'initialSnapshot',
    recordKey2: 'lineManagerId'
  };

  public static readonly initialCompanyManager: EditRecordRequest = {
    type: EditDataTypesEnum.EMPLOYEE,
    key: 'companyManagerId',
    recordKey1: 'initialSnapshot',
    recordKey2: 'companyManagerId'
  };

  public static readonly baseSalaryValidFrom: EditRecordRequest = {
    type: EditDataTypesEnum.DATE,
    key: 'baseSalaryValidFrom',
    recordKey1: 'initialSnapshot',
    recordKey2: 'baseSalaryValidFrom'
  };

  public static readonly measurementDate: EditRecordRequest = {
    type: EditDataTypesEnum.DATE,
    key: 'measurementDate',
    recordKey1: 'measurementDate'
  };

  public static readonly currentHrBusinessPartnerId: EditRecordRequest = {
    type: EditDataTypesEnum.EMPLOYEE,
    key: 'currentHrBusinessPartnerId',
    recordKey1: 'currentSnapshot',
    recordKey2: 'hrBusinessPartnerId'
  };

  public static readonly initialAllocationManagerId: EditRecordRequest = {
    type: EditDataTypesEnum.EMPLOYEE,
    key: 'initialAllocationManagerId',
    recordKey1: 'initialSnapshot',
    recordKey2: 'allocationManagerId'
  };

  public static readonly payoutState: EditRecordRequest = {
    type: EditDataTypesEnum.DROPDOWN_WITH_COMMENT,
    key: 'payoutState'
  };

  public static readonly payoutDate: EditRecordRequest = {
    type: EditDataTypesEnum.MONTH_DATE,
    key: 'payoutDate'
  };
  public static readonly approvalRequired: EditRecordRequest = {
    type: EditDataTypesEnum.DROPDOWN,
    key: 'approvalRequired'
  };
  public static readonly autoApprove: EditRecordRequest = {
    type: EditDataTypesEnum.DROPDOWN,
    key: 'autoApprove'
  };

  public static readonly individualMultiplierAmount: EditRecordRequest = {
    type: EditDataTypesEnum.DROPDOWN,
    key: 'individualMultiplierValue'
  };

  public static readonly initialTargetIncentiveAmount: EditRecordRequest = {
    type: EditDataTypesEnum.NUMBER,
    key: 'targetIncentiveAmount',
    recordKey1: 'initialSnapshot',
    recordKey2: 'targetIncentiveAmount'
  };
  public static readonly initialLocalCurrencyIsoCode: EditRecordRequest = {
    type: EditDataTypesEnum.TEXT,
    key: 'localCurrencyIsoCode',
    recordKey1: 'initialSnapshot',
    recordKey2: 'localCurrencyIsoCode'
  };
  public static readonly initialOrgCode: EditRecordRequest = {
    type: EditDataTypesEnum.TEXT,
    key: 'paOrgCode',
    recordKey1: 'initialSnapshot',
    recordKey2: 'paOrgCode'
  };
  public static readonly initialAreAndCountryOfAre: EditRecordRequest = {
    type: EditDataTypesEnum.DOUBLE_TEXT,
    key: 'areCode',
    special: SpecialRecordEdit.AreAndCountryOfAre,
    recordKey1: 'initialSnapshot',
    recordKey2: 'areCode'
  };
  public static readonly initialCostCenter: EditRecordRequest = {
    type: EditDataTypesEnum.TEXT,
    key: 'costCenter',
    recordKey1: 'initialSnapshot',
    recordKey2: 'costCenter'
  };
  public static readonly initialTargetIncentiveAmountValidFrom: EditRecordRequest = {
    type: EditDataTypesEnum.DATE,
    key: 'targetIncentiveAmountValidFrom',
    recordKey1: 'initialSnapshot',
    recordKey2: 'targetIncentiveAmountValidFrom'
  };
  public static readonly initialIncentivePaymentType: EditRecordRequest = {
    type: EditDataTypesEnum.TEXT,
    key: 'incentivePaymentType',
    recordKey1: 'initialSnapshot',
    recordKey2: 'incentivePaymentType'
  };
  public static readonly dateContractStatus: EditRecordRequest = {
    type: EditDataTypesEnum.DATE,
    key: 'dateContractStatus',
    recordKey1: 'initialSnapshot',
    recordKey2: 'dateContractStatus'
  };
  public static readonly dateManagementType: EditRecordRequest = {
    type: EditDataTypesEnum.DATE,
    key: 'dateManagementType',
    recordKey1: 'initialSnapshot',
    recordKey2: 'dateManagementType'
  };
  public static readonly orgClusterNodeName: EditRecordRequest = {
    type: EditDataTypesEnum.TEXT,
    key: 'orgClusterNodeName',
    recordKey1: 'initialSnapshot',
    recordKey2: 'orgClusterNodeName'
  };
  public static readonly orgClusterName: EditRecordRequest = {
    type: EditDataTypesEnum.TEXT,
    key: 'orgClusterName',
    recordKey1: 'initialSnapshot',
    recordKey2: 'orgClusterName'
  };
  public static readonly geoClusterNodeName: EditRecordRequest = {
    type: EditDataTypesEnum.TEXT,
    key: 'geoClusterNodeName',
    recordKey1: 'initialSnapshot',
    recordKey2: 'geoClusterNodeName'
  };
  public static readonly geoClusterName: EditRecordRequest = {
    type: EditDataTypesEnum.TEXT,
    key: 'geoClusterName',
    recordKey1: 'initialSnapshot',
    recordKey2: 'geoClusterName'
  };
  public static readonly locationOffice: EditRecordRequest = {
    type: EditDataTypesEnum.TEXT,
    key: 'locationOffice',
    recordKey1: 'initialSnapshot',
    recordKey2: 'locationOffice'
  };
  public static readonly managementGroup: EditRecordRequest = {
    type: EditDataTypesEnum.TEXT,
    key: 'managementGroup',
    recordKey1: 'initialSnapshot',
    recordKey2: 'managementGroup'
  };
  public static readonly personnelNumber: EditRecordRequest = {
    type: EditDataTypesEnum.TEXT,
    key: 'personnelNumber',
    recordKey1: 'initialSnapshot',
    recordKey2: 'personnelNumber'
  };
  public static readonly supplierId: EditRecordRequest = {
    type: EditDataTypesEnum.TEXT,
    key: 'supplierId',
    recordKey1: 'initialSnapshot',
    recordKey2: 'supplierId'
  };
  public static readonly contractStatusAndPlaceOfAction: EditRecordRequest = {
    type: EditDataTypesEnum.DOUBLE_TEXT,
    special: SpecialRecordEdit.ContractStatusAndPlaceOfAction,
    key: 'contractStatus',
    recordKey1: 'initialSnapshot',
    recordKey2: 'contractStatus'
  };
  public static readonly companyEntryDate: EditRecordRequest = {
    type: EditDataTypesEnum.DATE,
    key: 'companyEntryDate',
    recordKey1: 'initialSnapshot',
    recordKey2: 'companyEntryDate'
  };
  public static readonly actionTypeText: EditRecordRequest = {
    type: EditDataTypesEnum.TEXT,
    key: 'actionTypeText',
    recordKey1: 'initialSnapshot',
    recordKey2: 'actionTypeText'
  };
  public static readonly actionReasonText: EditRecordRequest = {
    type: EditDataTypesEnum.TEXT,
    key: 'actionReasonText',
    recordKey1: 'initialSnapshot',
    recordKey2: 'actionReasonText'
  };

  // SOG Requests (must have special: SpecialRecordEdit.SOG)

  public static readonly sogHrBusinessPartnerId: EditRecordRequest = {
    type: EditDataTypesEnum.HR_BP,
    key: 'hrBusinessPartnerId',
    special: SpecialRecordEdit.SOG
  };

  public static readonly sogBaseSalary: EditRecordRequest = {
    type: EditDataTypesEnum.NUMBER,
    key: 'baseSalary',
    special: SpecialRecordEdit.SOG
  };

  public static readonly sogBaseSalaryInEuro: EditRecordRequest = {
    type: EditDataTypesEnum.NUMBER,
    key: 'baseSalaryInEuro',
    special: SpecialRecordEdit.SOG
  };

  public static readonly sogBaseSalaryConversionDate: EditRecordRequest = {
    type: EditDataTypesEnum.DATE,
    key: 'baseSalaryConversionDate',
    special: SpecialRecordEdit.SOG
  };

  public static readonly sogLocalCurrency: EditRecordRequest = {
    type: EditDataTypesEnum.DROPDOWN,
    key: 'localCurrency',
    special: SpecialRecordEdit.SOG
  };

  public static readonly sogBaseSalaryValidFrom: EditRecordRequest = {
    type: EditDataTypesEnum.DATE,
    key: 'baseSalaryValidFrom',
    special: SpecialRecordEdit.SOG
  };

  public static readonly sogMeasurementDate: EditRecordRequest = {
    type: EditDataTypesEnum.DATE,
    key: 'measurementDate',
    special: SpecialRecordEdit.SOG
  };
}
